/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Report_Meta_TitleInputs */

const ja_playdata_report_meta_title = /** @type {(inputs: Playdata_Report_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025年版 日本eスポーツレポート（無料）`)
};

const en_playdata_report_meta_title = /** @type {(inputs: Playdata_Report_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FREE 2025 Japan Esports Report`)
};

/**
* | output |
* | --- |
* | "FREE 2025 Japan Esports Report" |
*
* @param {Playdata_Report_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_report_meta_title = /** @type {((inputs?: Playdata_Report_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Report_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_report_meta_title(inputs)
	return en_playdata_report_meta_title(inputs)
});